
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class MasterService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.cus_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_MASTER_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static updatePaymentTerm(input, responseCallBack, errorCallBack) {
    this.method("updatePaymentTerm", input, responseCallBack, errorCallBack);
  }
  static createPaymentTerm(input, responseCallBack, errorCallBack) {
    this.method("createPaymentTerm", input, responseCallBack, errorCallBack);
  }
  static getPaymentTermPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPaymentTermPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPaymentTerm(input, responseCallBack, errorCallBack) {
    this.method("readPaymentTerm", input, responseCallBack, errorCallBack);
  }
  static updateCurrency(input, responseCallBack, errorCallBack) {
    this.method("updateCurrency", input, responseCallBack, errorCallBack);
  }
  static createCurrency(input, responseCallBack, errorCallBack) {
    this.method("createCurrency", input, responseCallBack, errorCallBack);
  }
  static getCurrencyPageList(input, responseCallBack, errorCallBack) {
    this.method("getCurrencyPageList", input, responseCallBack, errorCallBack);
  }
  static readCurrency(input, responseCallBack, errorCallBack) {
    this.method("readCurrency", input, responseCallBack, errorCallBack);
  }
  static updateUOM(input, responseCallBack, errorCallBack) {
    this.method("updateUOM", input, responseCallBack, errorCallBack);
  }
  static createUOM(input, responseCallBack, errorCallBack) {
    this.method("createUOM", input, responseCallBack, errorCallBack);
  }
  static getUOMPageList(input, responseCallBack, errorCallBack) {
    this.method("getUOMPageList", input, responseCallBack, errorCallBack);
  }
  static readUOM(input, responseCallBack, errorCallBack) {
    this.method("readUOM", input, responseCallBack, errorCallBack);
  }
  static updateEmployee(input, responseCallBack, errorCallBack) {
    this.method("updateEmployee", input, responseCallBack, errorCallBack);
  }
  static createEmployee(input, responseCallBack, errorCallBack) {
    this.method("createEmployee", input, responseCallBack, errorCallBack);
  }
  static getEmployeePageList(input, responseCallBack, errorCallBack) {
    this.method("getEmployeePageList", input, responseCallBack, errorCallBack);
  }
  static readEmployee(input, responseCallBack, errorCallBack) {
    this.method("readEmployee", input, responseCallBack, errorCallBack);
  }
  static updateCountry(input, responseCallBack, errorCallBack) {
    this.method("updateCountry", input, responseCallBack, errorCallBack);
  }
  static updateState(input, responseCallBack, errorCallBack) {
    this.method("updateState", input, responseCallBack, errorCallBack);
  }
  static updateCity(input, responseCallBack, errorCallBack) {
    this.method("updateCity", input, responseCallBack, errorCallBack);
  }
  static updateColor(input, responseCallBack, errorCallBack) {
    this.method("updateColor", input, responseCallBack, errorCallBack);
  }
  static updateSeason(input, responseCallBack, errorCallBack) {
    this.method("updateSeason", input, responseCallBack, errorCallBack);
  }
  static updateComment(input, responseCallBack, errorCallBack) {
    this.method("updateComment", input, responseCallBack, errorCallBack);
  }
  static updateProductStatus(input, responseCallBack, errorCallBack) {
    this.method("updateProductStatus", input, responseCallBack, errorCallBack);
  }
  static updateStyleItemType(input, responseCallBack, errorCallBack) {
    this.method("updateStyleItemType", input, responseCallBack, errorCallBack);
  }
  static updateBankAccount(input, responseCallBack, errorCallBack) {
    this.method("updateBankAccount", input, responseCallBack, errorCallBack);
  }
  static updateProductDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "updateProductDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCompositionType(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCompositionType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateBusinessDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "updateBusinessDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePatternType(input, responseCallBack, errorCallBack) {
    this.method("updatePatternType", input, responseCallBack, errorCallBack);
  }
  static updateMakeType(input, responseCallBack, errorCallBack) {
    this.method("updateMakeType", input, responseCallBack, errorCallBack);
  }
  static updateProductType(input, responseCallBack, errorCallBack) {
    this.method("updateProductType", input, responseCallBack, errorCallBack);
  }
  static updatePatternTypeCategory(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePatternTypeCategory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCountry(input, responseCallBack, errorCallBack) {
    this.method("createCountry", input, responseCallBack, errorCallBack);
  }
  static createState(input, responseCallBack, errorCallBack) {
    this.method("createState", input, responseCallBack, errorCallBack);
  }
  static createCity(input, responseCallBack, errorCallBack) {
    this.method("createCity", input, responseCallBack, errorCallBack);
  }
  static createColor(input, responseCallBack, errorCallBack) {
    this.method("createColor", input, responseCallBack, errorCallBack);
  }
  static createSeason(input, responseCallBack, errorCallBack) {
    this.method("createSeason", input, responseCallBack, errorCallBack);
  }
  static createComment(input, responseCallBack, errorCallBack) {
    this.method("createComment", input, responseCallBack, errorCallBack);
  }
  static createProductStatus(input, responseCallBack, errorCallBack) {
    this.method("createProductStatus", input, responseCallBack, errorCallBack);
  }
  static createStyleItemType(input, responseCallBack, errorCallBack) {
    this.method("createStyleItemType", input, responseCallBack, errorCallBack);
  }
  static createBankAccount(input, responseCallBack, errorCallBack) {
    this.method("createBankAccount", input, responseCallBack, errorCallBack);
  }
  static createProductDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "createProductDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCompositionType(input, responseCallBack, errorCallBack) {
    this.method(
      "createCompositionType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createBusinessDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "createBusinessDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPatternType(input, responseCallBack, errorCallBack) {
    this.method("createPatternType", input, responseCallBack, errorCallBack);
  }
  static createMakeType(input, responseCallBack, errorCallBack) {
    this.method("createMakeType", input, responseCallBack, errorCallBack);
  }
  static createProductType(input, responseCallBack, errorCallBack) {
    this.method("createProductType", input, responseCallBack, errorCallBack);
  }
  static createPatternTypeCategory(input, responseCallBack, errorCallBack) {
    this.method(
      "createPatternTypeCategory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCountryPageList(input, responseCallBack, errorCallBack) {
    this.method("getCountryPageList", input, responseCallBack, errorCallBack);
  }
  static getStatePageList(input, responseCallBack, errorCallBack) {
    this.method("getStatePageList", input, responseCallBack, errorCallBack);
  }
  static getCityPageList(input, responseCallBack, errorCallBack) {
    this.method("getCityPageList", input, responseCallBack, errorCallBack);
  }
  static getColorPageList(input, responseCallBack, errorCallBack) {
    this.method("getColorPageList", input, responseCallBack, errorCallBack);
  }
  static getSeasonPageList(input, responseCallBack, errorCallBack) {
    this.method("getSeasonPageList", input, responseCallBack, errorCallBack);
  }
  static getCommentPageList(input, responseCallBack, errorCallBack) {
    this.method("getCommentPageList", input, responseCallBack, errorCallBack);
  }
  static getProductStatusPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getProductStatusPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getStyleItemTypePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getStyleItemTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getBankAccountPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getBankAccountPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getProductDivisionPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getProductDivisionPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCompositionTypePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCompositionTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getBusinessDivisionPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getBusinessDivisionPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPatternTypePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPatternTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getMakeTypePageList(input, responseCallBack, errorCallBack) {
    this.method("getMakeTypePageList", input, responseCallBack, errorCallBack);
  }
  static getProductTypePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getProductTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPatternTypeCategoryPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPatternTypeCategoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCountry(input, responseCallBack, errorCallBack) {
    this.method("readCountry", input, responseCallBack, errorCallBack);
  }
  static readStateWithCountryCode(input, responseCallBack, errorCallBack) {
    this.method(
      "readStateWithCountryCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCity(input, responseCallBack, errorCallBack) {
    this.method("readCity", input, responseCallBack, errorCallBack);
  }
  static readColor(input, responseCallBack, errorCallBack) {
    this.method("readColor", input, responseCallBack, errorCallBack);
  }
  static readSeason(input, responseCallBack, errorCallBack) {
    this.method("readSeason", input, responseCallBack, errorCallBack);
  }
  static readComment(input, responseCallBack, errorCallBack) {
    this.method("readComment", input, responseCallBack, errorCallBack);
  }
  static readProductStatus(input, responseCallBack, errorCallBack) {
    this.method("readProductStatus", input, responseCallBack, errorCallBack);
  }
  static readStyleItemType(input, responseCallBack, errorCallBack) {
    this.method("readStyleItemType", input, responseCallBack, errorCallBack);
  }
  static readBankAccount(input, responseCallBack, errorCallBack) {
    this.method("readBankAccount", input, responseCallBack, errorCallBack);
  }
  static readProductDivision(input, responseCallBack, errorCallBack) {
    this.method("readProductDivision", input, responseCallBack, errorCallBack);
  }
  static readCompositionType(input, responseCallBack, errorCallBack) {
    this.method("readCompositionType", input, responseCallBack, errorCallBack);
  }
  static readBusinessDivision(input, responseCallBack, errorCallBack) {
    this.method("readBusinessDivision", input, responseCallBack, errorCallBack);
  }
  static readPatternType(input, responseCallBack, errorCallBack) {
    this.method("readPatternType", input, responseCallBack, errorCallBack);
  }
  static readMakeType(input, responseCallBack, errorCallBack) {
    this.method("readMakeType", input, responseCallBack, errorCallBack);
  }
  static readProductType(input, responseCallBack, errorCallBack) {
    this.method("readProductType", input, responseCallBack, errorCallBack);
  }
  static readPatternTypeCategory(input, responseCallBack, errorCallBack) {
    this.method(
      "readPatternTypeCategory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCurrencyExchangeRate(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCurrencyExchangeRate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCurrencyExchangeRate(input, responseCallBack, errorCallBack) {
    this.method(
      "createCurrencyExchangeRate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCurrencyExchangeRatePageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCurrencyExchangeRatePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCurrencyExchangeRate(input, responseCallBack, errorCallBack) {
    this.method(
      "readCurrencyExchangeRate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateShipTo(input, responseCallBack, errorCallBack) {
    this.method("updateShipTo", input, responseCallBack, errorCallBack);
  }
  static createShipTo(input, responseCallBack, errorCallBack) {
    this.method("createShipTo", input, responseCallBack, errorCallBack);
  }
  static getShipToPageList(input, responseCallBack, errorCallBack) {
    this.method("getShipToPageList", input, responseCallBack, errorCallBack);
  }
  static readShipTo(input, responseCallBack, errorCallBack) {
    this.method("readShipTo", input, responseCallBack, errorCallBack);
  }
  static getFabricVendorMiscellaneousCostDetailReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricVendorMiscellaneousCostDetailReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricVendorMiscellaneousCostDetailReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createFabricVendorMiscellaneousCostDetailReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateFabricVendorMiscellaneousCostDetailReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateFabricVendorMiscellaneousCostDetailReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readFabricVendorMiscellaneousCostDetailReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readFabricVendorMiscellaneousCostDetailReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getRoyaltyClientPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getRoyaltyClientPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createRoyaltyClient(input, responseCallBack, errorCallBack) {
    this.method("createRoyaltyClient", input, responseCallBack, errorCallBack);
  }

  static updateRoyaltyClient(input, responseCallBack, errorCallBack) {
    this.method("updateRoyaltyClient", input, responseCallBack, errorCallBack);
  }
  static readRoyaltyClient(input, responseCallBack, errorCallBack) {
    this.method("readRoyaltyClient", input, responseCallBack, errorCallBack);
  }
  static getFiscalYearsPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getFiscalYearsPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFiscalYear(input, responseCallBack, errorCallBack) {
    this.method("createFiscalYear", input, responseCallBack, errorCallBack);
  }
  static updateFiscalYear(input, responseCallBack, errorCallBack) {
    this.method("updateFiscalYear", input, responseCallBack, errorCallBack);
  }
  static readFiscalYear(input, responseCallBack, errorCallBack) {
    this.method("readFiscalYear", input, responseCallBack, errorCallBack);
  }
  static getHarmonizedTariffSchedulePageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getHarmonizedTariffSchedulePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createHarmonizedTariffSchedule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createHarmonizedTariffSchedule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateHarmonizedTariffSchedule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateHarmonizedTariffSchedule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readHarmonizedTariffSchedule(input, responseCallBack, errorCallBack) {
    this.method(
      "readHarmonizedTariffSchedule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInventoryAdjustmentPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInventoryAdjustmentPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInventoryAdjustmentReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInventoryAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInventoryAdjustmentReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateInventoryAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readInventoryAdjustmentReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readInventoryAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getWarehousePageList(input, responseCallBack, errorCallBack) {
    this.method("getWarehousePageList", input, responseCallBack, errorCallBack);
  }
  static createWarehouse(input, responseCallBack, errorCallBack) {
    this.method("createWarehouse", input, responseCallBack, errorCallBack);
  }
  static updateWarehouse(input, responseCallBack, errorCallBack) {
    this.method("updateWarehouse", input, responseCallBack, errorCallBack);
  }
  static readWarehouse(input, responseCallBack, errorCallBack) {
    this.method("readWarehouse", input, responseCallBack, errorCallBack);
  }
  static getCustomerDivisionPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerDivisionPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "createCustomerDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCustomerDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerDivision(input, responseCallBack, errorCallBack) {
    this.method("readCustomerDivision", input, responseCallBack, errorCallBack);
  }
  static getCustomerSalesZonePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerSalesZonePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerSalesZone(input, responseCallBack, errorCallBack) {
    this.method(
      "createCustomerSalesZone",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerSalesZone(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCustomerSalesZone",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerSalesZone(input, responseCallBack, errorCallBack) {
    this.method(
      "readCustomerSalesZone",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFreightMethodsPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getFreightMethodsPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFreightMethod(input, responseCallBack, errorCallBack) {
    this.method("createFreightMethod", input, responseCallBack, errorCallBack);
  }
  static updateFreightMethod(input, responseCallBack, errorCallBack) {
    this.method("updateFreightMethod", input, responseCallBack, errorCallBack);
  }
  static readFreightMethod(input, responseCallBack, errorCallBack) {
    this.method("readFreightMethod", input, responseCallBack, errorCallBack);
  }
  static getShipViaPageList(input, responseCallBack, errorCallBack) {
    this.method("getShipViaPageList", input, responseCallBack, errorCallBack);
  }
  static createShipVia(input, responseCallBack, errorCallBack) {
    this.method("createShipVia", input, responseCallBack, errorCallBack);
  }
  static updateShipVia(input, responseCallBack, errorCallBack) {
    this.method("updateShipVia", input, responseCallBack, errorCallBack);
  }
  static readShipVia(input, responseCallBack, errorCallBack) {
    this.method("readShipVia", input, responseCallBack, errorCallBack);
  }
  static getBoxTypePageList(input, responseCallBack, errorCallBack) {
    this.method("getBoxTypePageList", input, responseCallBack, errorCallBack);
  }
  static createBoxType(input, responseCallBack, errorCallBack) {
    this.method("createBoxType", input, responseCallBack, errorCallBack);
  }
  static updateBoxType(input, responseCallBack, errorCallBack) {
    this.method("updateBoxType", input, responseCallBack, errorCallBack);
  }
  static readBoxType(input, responseCallBack, errorCallBack) {
    this.method("readBoxType", input, responseCallBack, errorCallBack);
  }
  static getInvoiceCancelReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceCancelReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createInvoiceCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoiceCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updateInvoiceCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readInvoiceCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readInvoiceCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerDeliveryPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerDeliveryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerDelivery(input, responseCallBack, errorCallBack) {
    this.method(
      "createCustomerDelivery",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerDelivery(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCustomerDelivery",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerDelivery(input, responseCallBack, errorCallBack) {
    this.method("readCustomerDelivery", input, responseCallBack, errorCallBack);
  }
  static getPaymentMethodPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPaymentMethodPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPaymentMethod(input, responseCallBack, errorCallBack) {
    this.method("createPaymentMethod", input, responseCallBack, errorCallBack);
  }
  static updatePaymentMethod(input, responseCallBack, errorCallBack) {
    this.method("updatePaymentMethod", input, responseCallBack, errorCallBack);
  }
  static readPaymentMethod(input, responseCallBack, errorCallBack) {
    this.method("readPaymentMethod", input, responseCallBack, errorCallBack);
  }
  static getInvoiceTemplatePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getInvoiceTemplatePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceTemplate(input, responseCallBack, errorCallBack) {
    this.method(
      "createInvoiceTemplate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoiceTemplate(input, responseCallBack, errorCallBack) {
    this.method(
      "updateInvoiceTemplate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readInvoiceTemplate(input, responseCallBack, errorCallBack) {
    this.method("readInvoiceTemplate", input, responseCallBack, errorCallBack);
  }
  static getInvoiceUnApprovalPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getInvoiceUnApprovalPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceUnApprovalReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createInvoiceUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoiceUnApprovalReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updateInvoiceUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readInvoiceUnApprovalReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readInvoiceUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoiceNonMerchandiseReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoiceNonMerchandiseReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceNonMerchandiseReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInvoiceNonMerchandiseReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoiceNonMerchandiseReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateInvoiceNonMerchandiseReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readInvoiceNonMerchandiseReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readInvoiceNonMerchandiseReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPeriodSalesCommissionAdjustmentReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPeriodSalesCommissionAdjustmentReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPeriodSalesCommissionAdjustmentReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createPeriodSalesCommissionAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePeriodSalesCommissionAdjustmentReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePeriodSalesCommissionAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPeriodSalesCommissionAdjustmentReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readPeriodSalesCommissionAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorTypePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createVendorType(input, responseCallBack, errorCallBack) {
    this.method("createVendorType", input, responseCallBack, errorCallBack);
  }
  static updateVendorType(input, responseCallBack, errorCallBack) {
    this.method("updateVendorType", input, responseCallBack, errorCallBack);
  }
  static readVendorType(input, responseCallBack, errorCallBack) {
    this.method("readVendorType", input, responseCallBack, errorCallBack);
  }
  static getIncoTermPageList(input, responseCallBack, errorCallBack) {
    this.method("getIncoTermPageList", input, responseCallBack, errorCallBack);
  }
  static createIncoTerm(input, responseCallBack, errorCallBack) {
    this.method("createIncoTerm", input, responseCallBack, errorCallBack);
  }
  static updateIncoTerm(input, responseCallBack, errorCallBack) {
    this.method("updateIncoTerm", input, responseCallBack, errorCallBack);
  }
  static readIncoTerm(input, responseCallBack, errorCallBack) {
    this.method("readIncoTerm", input, responseCallBack, errorCallBack);
  }
  static getVendorShipViaPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorShipViaPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createVendorShipVia(input, responseCallBack, errorCallBack) {
    this.method("createVendorShipVia", input, responseCallBack, errorCallBack);
  }
  static updateVendorShipVia(input, responseCallBack, errorCallBack) {
    this.method("updateVendorShipVia", input, responseCallBack, errorCallBack);
  }
  static readVendorShipVia(input, responseCallBack, errorCallBack) {
    this.method("readVendorShipVia", input, responseCallBack, errorCallBack);
  }
  static getVendorTermPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorTermPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createVendorTerm(input, responseCallBack, errorCallBack) {
    this.method("createVendorTerm", input, responseCallBack, errorCallBack);
  }
  static updateVendorTerm(input, responseCallBack, errorCallBack) {
    this.method("updateVendorTerm", input, responseCallBack, errorCallBack);
  }
  static readVendorTerm(input, responseCallBack, errorCallBack) {
    this.method("readVendorTerm", input, responseCallBack, errorCallBack);
  }
  static getShipmentTermPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getShipmentTermPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createShipmentTerm(input, responseCallBack, errorCallBack) {
    this.method("createShipmentTerm", input, responseCallBack, errorCallBack);
  }
  static updateShipmentTerm(input, responseCallBack, errorCallBack) {
    this.method("updateShipmentTerm", input, responseCallBack, errorCallBack);
  }
  static readShipmentTerm(input, responseCallBack, errorCallBack) {
    this.method("readShipmentTerm", input, responseCallBack, errorCallBack);
  }
  static getVendorCategoryPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorCategoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createVendorCategory(input, responseCallBack, errorCallBack) {
    this.method("createVendorCategory", input, responseCallBack, errorCallBack);
  }
  static updateVendorCategory(input, responseCallBack, errorCallBack) {
    this.method("updateVendorCategory", input, responseCallBack, errorCallBack);
  }
  static readVendorCategory(input, responseCallBack, errorCallBack) {
    this.method("readVendorCategory", input, responseCallBack, errorCallBack);
  }
  static getPurchaseOrderCancelPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderCancelPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPurchaseOrderCancelReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createPurchaseOrderCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrderCancelReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePurchaseOrderCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPurchaseOrderCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readPurchaseOrderCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderUnApprovalPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderUnApprovalPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPurchaseOrderUnApprovalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createPurchaseOrderUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrderUnApprovalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePurchaseOrderUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPurchaseOrderUnApprovalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readPurchaseOrderUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getMiscellaneousChargeReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getMiscellaneousChargeReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createMiscellaneousChargeReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createMiscellaneousChargeReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateMiscellaneousChargeReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateMiscellaneousChargeReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readMiscellaneousChargeReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readMiscellaneousChargeReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderModelPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPurchaseOrderModelPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPurchaseOrderModel(input, responseCallBack, errorCallBack) {
    this.method(
      "createPurchaseOrderModel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrderModel(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePurchaseOrderModel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPurchaseOrderModel(input, responseCallBack, errorCallBack) {
    this.method(
      "readPurchaseOrderModel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getGeneralLedgerAccountTypePageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getGeneralLedgerAccountTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createGeneralLedgerAccountType(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createGeneralLedgerAccountType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateGeneralLedgerAccountType(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateGeneralLedgerAccountType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readGeneralLedgerAccountType(input, responseCallBack, errorCallBack) {
    this.method(
      "readGeneralLedgerAccountType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getGeneralLedgerAccountPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getGeneralLedgerAccountPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createGeneralLedgerAccount(input, responseCallBack, errorCallBack) {
    this.method(
      "createGeneralLedgerAccount",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateGeneralLedgerAccount(input, responseCallBack, errorCallBack) {
    this.method(
      "updateGeneralLedgerAccount",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readGeneralLedgerAccount(input, responseCallBack, errorCallBack) {
    this.method(
      "readGeneralLedgerAccount",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAccountReceivableDiscountDetailReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAccountReceivableDiscountDetailReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAccountReceivableDiscountDetailReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAccountReceivableDiscountDetailReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAccountReceivableDiscountDetailReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAccountReceivableDiscountDetailReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readAccountReceivableDiscountDetailReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readAccountReceivableDiscountDetailReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerTenderReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerTenderReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerTenderReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createCustomerTenderReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerTenderReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCustomerTenderReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerTenderReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readCustomerTenderReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomertenderCancelReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomertenderCancelReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerTenderCancelReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createCustomerTenderCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerTenderCancelReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateCustomerTenderCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerTenderCancelReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCustomerTenderCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerTenderUnApprovalPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerTenderUnApprovalPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerTenderUnApprovalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createCustomerTenderUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerTenderUnApprovalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateCustomerTenderUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerTenderUnApprovalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readCustomerTenderUnApprovalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAccountReceivableReversalReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAccountReceivableReversalReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAccountReceivableReversalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAccountReceivableReversalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAccountReceivableReversalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAccountReceivableReversalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readAccountReceivableReversalReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readAccountReceivableReversalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getExpenseTypesPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getExpenseTypesPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createExpenseType(input, responseCallBack, errorCallBack) {
    this.method("createExpenseType", input, responseCallBack, errorCallBack);
  }
  static updateExpenseType(input, responseCallBack, errorCallBack) {
    this.method("updateExpenseType", input, responseCallBack, errorCallBack);
  }
  static readExpenseType(input, responseCallBack, errorCallBack) {
    this.method("readExpenseType", input, responseCallBack, errorCallBack);
  }
  static getExpenseSubTypesPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getExpenseSubTypesPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createExpenseSubType(input, responseCallBack, errorCallBack) {
    this.method("createExpenseSubType", input, responseCallBack, errorCallBack);
  }
  static updateExpenseSubType(input, responseCallBack, errorCallBack) {
    this.method("updateExpenseSubType", input, responseCallBack, errorCallBack);
  }
  static readExpenseSubType(input, responseCallBack, errorCallBack) {
    this.method("readExpenseSubType", input, responseCallBack, errorCallBack);
  }
  static getBankAdjustmentReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getBankAdjustmentReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createBankAdjustmentReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createBankAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateBankAdjustmentReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updateBankAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readBankAdjustmentReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readBankAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDepositCancelReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDepositCancelReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createDepositCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createDepositCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateDepositCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updateDepositCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readDepositCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readDepositCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDepositReversalReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDepositReversalReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createDepositReversalReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createDepositReversalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateDepositReversalReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updateDepositReversalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readDepositReversalReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readDepositReversalReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPreProductionChangeReasonPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPreProductionChangeReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPreProductionChangeReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createPreProductionChangeReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePreProductionChangesReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePreProductionChangesReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPreProductionReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readPreProductionReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricDetailsPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricDetailsPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricDetail(input, responseCallBack, errorCallBack) {
    this.method("createFabricDetail", input, responseCallBack, errorCallBack);
  }
  static updateFabricDetail(input, responseCallBack, errorCallBack) {
    this.method("updateFabricDetail", input, responseCallBack, errorCallBack);
  }
  static readFabricDetail(input, responseCallBack, errorCallBack) {
    this.method("readFabricDetail", input, responseCallBack, errorCallBack);
  }
  static getStageCollections(input, responseCallBack, errorCallBack) {
    this.method("getStageCollections", input, responseCallBack, errorCallBack);
  }
  static createStageCollection(input, responseCallBack, errorCallBack) {
    this.method(
      "createStageCollection",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateStageCollection(input, responseCallBack, errorCallBack) {
    this.method(
      "updateStageCollection",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readStageCollection(input, responseCallBack, errorCallBack) {
    this.method("readStageCollection", input, responseCallBack, errorCallBack);
  }
  static getLogisticMethodsPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getLogisticMethodsPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createLogisticMethod(input, responseCallBack, errorCallBack) {
    this.method("createLogisticMethod", input, responseCallBack, errorCallBack);
  }
  static updateLogisticMethod(input, responseCallBack, errorCallBack) {
    this.method("updateLogisticMethod", input, responseCallBack, errorCallBack);
  }
  static readLogisticMethod(input, responseCallBack, errorCallBack) {
    this.method("readLogisticMethod", input, responseCallBack, errorCallBack);
  }
  static getCustomerTypesPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerTypesPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerType(input, responseCallBack, errorCallBack) {
    this.method("createCustomerType", input, responseCallBack, errorCallBack);
  }
  static updateCustomerType(input, responseCallBack, errorCallBack) {
    this.method("updateCustomerType", input, responseCallBack, errorCallBack);
  }
  static readCustomerType(input, responseCallBack, errorCallBack) {
    this.method("readCustomerType", input, responseCallBack, errorCallBack);
  }
  static getCustomerSpecialTypesPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerSpecialTypesPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCustomerSpecialType(input, responseCallBack, errorCallBack) {
    this.method(
      "createCustomerSpecialType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCustomerSpecialType(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCustomerSpecialType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerSpecialType(input, responseCallBack, errorCallBack) {
    this.method(
      "readCustomerSpecialType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateTargetWebSiteDetail(input, responseCallBack, errorCallBack) {
    this.method(
      "updateTargetWebSiteDetail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readTargetWebSiteDetail(input, responseCallBack, errorCallBack) {
    this.method(
      "readTargetWebSiteDetail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getTargetWebSiteDetailsPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getTargetWebSiteDetailsPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createTargetWebSiteDetail(input, responseCallBack, errorCallBack) {
    this.method(
      "createTargetWebSiteDetail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFobCity(input, responseCallBack, errorCallBack) {
    this.method("createFobCity", input, responseCallBack, errorCallBack);
  }
  static getFobCityPageList(input, responseCallBack, errorCallBack) {
    this.method("getFobCityPageList", input, responseCallBack, errorCallBack);
  }
  static readFobCity(input, responseCallBack, errorCallBack) {
    this.method("readFobCity", input, responseCallBack, errorCallBack);
  }
  static updateFobCity(input, responseCallBack, errorCallBack) {
    this.method("updateFobCity", input, responseCallBack, errorCallBack);
  }
  static deleteFobCity(input, responseCallBack, errorCallBack) {
    this.method("deleteFobCity", input, responseCallBack, errorCallBack);
  }
  static deleteCountry(input, responseCallBack, errorCallBack) {
    this.method("deleteCountry", input, responseCallBack, errorCallBack);
  }
  static deleteMakeType(input, responseCallBack, errorCallBack) {
    this.method("deleteMakeType", input, responseCallBack, errorCallBack);
  }
  static deletePatternType(input, responseCallBack, errorCallBack) {
    this.method("deletePatternType", input, responseCallBack, errorCallBack);
  }
  static deleteUOM(input, responseCallBack, errorCallBack) {
    this.method("deleteUOM", input, responseCallBack, errorCallBack);
  }
  static deleteRoyaltyClient(input, responseCallBack, errorCallBack) {
    this.method("deleteRoyaltyClient", input, responseCallBack, errorCallBack);
  }
  static deleteInventoryAdjustmentReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "deleteInventoryAdjustmentReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteHarmonizedTariffSchedule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "deleteHarmonizedTariffSchedule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteLogisticMethod(input, responseCallBack, errorCallBack) {
    this.method("deleteLogisticMethod", input, responseCallBack, errorCallBack);
  }
  static deleteBoxType(input, responseCallBack, errorCallBack) {
    this.method("deleteBoxType", input, responseCallBack, errorCallBack);
  }
  static deleteCustomerType(input, responseCallBack, errorCallBack) {
    this.method("deleteCustomerType", input, responseCallBack, errorCallBack);
  }
  static deleteCustomerTender(input, responseCallBack, errorCallBack) {
    this.method("deleteCustomerTender", input, responseCallBack, errorCallBack);
  }
  static deleteMiscellaneousChargeReason(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "deleteMiscellaneousChargeReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteVendorTerm(input, responseCallBack, errorCallBack) {
    this.method("deleteVendorTerm", input, responseCallBack, errorCallBack);
  }
  static deleteExpenseType(input, responseCallBack, errorCallBack) {
    this.method("deleteExpenseType", input, responseCallBack, errorCallBack);
  }
  static deleteColor(input, responseCallBack, errorCallBack) {
    this.method("deleteColor", input, responseCallBack, errorCallBack);
  }
  static deleteCompositionType(input, responseCallBack, errorCallBack) {
    this.method(
      "deleteCompositionType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteProductType(input, responseCallBack, errorCallBack) {
    this.method("deleteProductType", input, responseCallBack, errorCallBack);
  }
  static deleteVendorShipVia(input, responseCallBack, errorCallBack) {
    this.method("deleteVendorShipVia", input, responseCallBack, errorCallBack);
  }
  static deleteShipmentTerm(input, responseCallBack, errorCallBack) {
    this.method("deleteShipmentTerm", input, responseCallBack, errorCallBack);
  }
  static deleteIncoTerm(input, responseCallBack, errorCallBack) {
    this.method("deleteIncoTerm", input, responseCallBack, errorCallBack);
  }
  static deleteVendorCategory(input, responseCallBack, errorCallBack) {
    this.method("deleteVendorCategory", input, responseCallBack, errorCallBack);
  }
  static deleteCustomerSalesZone(input, responseCallBack, errorCallBack) {
    this.method(
      "deleteCustomerSalesZone",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteCustomerDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "deleteCustomerDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteEmployee(input, responseCallBack, errorCallBack) {
    this.method("deleteEmployee", input, responseCallBack, errorCallBack);
  }
  static deleteShipVia(input, responseCallBack, errorCallBack) {
    this.method("deleteShipVia", input, responseCallBack, errorCallBack);
  }
  static deleteProductDivision(input, responseCallBack, errorCallBack) {
    this.method(
      "deleteProductDivision",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteWarehouse(input, responseCallBack, errorCallBack) {
    this.method("deleteWarehouse", input, responseCallBack, errorCallBack);
  }
  static createFobCity(input, responseCallBack, errorCallBack) {
    this.method("createFobCity", input, responseCallBack, errorCallBack);
  }
  static getFobCityPageList(input, responseCallBack, errorCallBack) {
    this.method("getFobCityPageList", input, responseCallBack, errorCallBack);
  }
  static readFobCity(input, responseCallBack, errorCallBack) {
    this.method("readFobCity", input, responseCallBack, errorCallBack);
  }
  static updateFobCity(input, responseCallBack, errorCallBack) {
    this.method("updateFobCity", input, responseCallBack, errorCallBack);
  }
  static deleteFobCity(input, responseCallBack, errorCallBack) {
    this.method("deleteFobCity", input, responseCallBack, errorCallBack);
  }
  static getFobCityPageListByCriteria(input, responseCallBack, errorCallBack) {
    this.method(
      "getFobCityPageListByCriteria",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerTypesPageListByCriteria(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerTypesPageListByCriteria",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getWarehousePageListByCriteria(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getWarehousePageListByCriteria",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getProductStatusPageListByCriteria(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getProductStatusPageListByCriteria",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getLogisticMethodsPageListByCriteria(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getLogisticMethodsPageListByCriteria",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCustomerSpecialTypesPageListByCriteria(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCustomerSpecialTypesPageListByCriteria",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createService(input, responseCallBack, errorCallBack) {
    this.method("createService", input, responseCallBack, errorCallBack);
  }
  static updateService(input, responseCallBack, errorCallBack) {
    this.method("updateService", input, responseCallBack, errorCallBack);
  }
  static readService(input, responseCallBack, errorCallBack) {
    this.method("readService", input, responseCallBack, errorCallBack);
  }
  static getServicePageList(input, responseCallBack, errorCallBack) {
    this.method("getServicePageList", input, responseCallBack, errorCallBack);
  }
  static createBinLocation(input, responseCallBack, errorCallBack) {
    this.method("createBinLocation", input, responseCallBack, errorCallBack);
  }
  static updateBinLocation(input, responseCallBack, errorCallBack) {
    this.method("updateBinLocation", input, responseCallBack, errorCallBack);
  }
  static readBinLocation(input, responseCallBack, errorCallBack) {
    this.method("readBinLocation", input, responseCallBack, errorCallBack);
  }
  static getBinLocationPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getBinLocationPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAttributeCache(input, responseCallBack, errorCallBack) {
    this.method("getAttributeCache", input, responseCallBack, errorCallBack);
  }
  static invoiceReportTypeLogoUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "invoiceReportTypeLogoUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoicePrintoutType(input, responseCallBack, errorCallBack) {
    this.method(
      "createInvoicePrintoutType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readInvoicePrintoutType(input, responseCallBack, errorCallBack) {
    this.method(
      "readInvoicePrintoutType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoicePrintoutType(input, responseCallBack, errorCallBack) {
    this.method(
      "updateInvoicePrintoutType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInvoicePrintoutTypePageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInvoicePrintoutTypePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static deleteInvoicePrintoutType(input, responseCallBack, errorCallBack) {
    this.method(
      "deleteInvoicePrintoutType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
static getPickTicketCancelReasonPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPickTicketCancelReasonPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }

   static createPickTicketCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "createPickTicketCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }

   static updatePickTicketCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePickTicketCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }

   static readPickTicketCancelReason(input, responseCallBack, errorCallBack) {
    this.method(
      "readPickTicketCancelReason",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
 static updateInvoiceModel(input, responseCallBack, errorCallBack) {
    this.method("updateInvoiceModel", input, responseCallBack, errorCallBack);
  }
  static createInvoiceModel(input, responseCallBack, errorCallBack) {
    this.method("createInvoiceModel", input, responseCallBack, errorCallBack);
  }
  static getInvoiceModelPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getInvoiceModelPageList",
      input,
      responseCallBack,
      errorCallBack,
    );
  }
  static readInvoiceModel(input, responseCallBack, errorCallBack) {
    this.method("readInvoiceModel", input, responseCallBack, errorCallBack);
  }  
  

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.cus_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.cus_data_url,responseCallBack, errorCallBack);
    }
  }
}
